/******************************************************************************************
 *	Curtain Notifications
 *******************************************************************************************
 *
 * Curtain notifications are non-intruding, small, temporary notifications that slide down from the top of the
 * viewport, covering the application header. They go away after 5 seconds (default, configurable) or when the
 * user clicks the dismiss button.
 *
 */
(function() {
  

  angular
    .module('rcServices.curtainNotifications', [])
    .service(
      'CurtainNotifications',
      /* @ngInject */
      function(_, $rootScope) {
        var self = this;

        //Alert types
        this.NOTICE = 'notice';
        this.ERROR = 'error';
        this.SUCCESS = 'success';
        this.INFO = 'info';
        this.INFO_LONG = 'info-long'; // Has styling allowing it to be wrapped to multiple lines if needed
        this.HELP = 'help';

        var alertTypes = [
          this.NOTICE,
          this.ERROR,
          this.SUCCESS,
          this.INFO,
          this.HELP,
          this.INFO_LONG
        ];
        var defaultType = this.NOTICE;

        var applyChanges = function() {
          if (!$rootScope.$$phase) {
            $rootScope.$apply();
          }
        };

        //Number of milliseconds the notification is visible on screen without user interaction
        var defaultLifetime = 5000;
        var lifetimeTimeout;

        var isVisible = false; //Controls visibility of notification
        var type = defaultType; //Type of the notification
        var message = ''; //Message to be displayed to the user
        var interpolateParams; //Translation variables for interpolation
        var automationId = ''; // automation-id value, only used to by automation to identify notification

        this.isVisible = function() {
          return isVisible;
        };
        this.getType = function() {
          return type;
        };
        this.getMessage = function() {
          return message;
        };
        this.getInterpolateParams = function() {
          return interpolateParams;
        };
        this.getAutomationId = function() {
          return automationId;
        };

        this.show = function(alertType, alertMessage, translationVars, lifetime) {
          isVisible = true;
          type = _.includes(alertTypes, alertType) ? alertType : defaultType;
          message = alertMessage;
          interpolateParams = translationVars;
          // Construct an automation-id value from the type and string key. This should be unique per
          // string/message, if not per workflow, and should be sufficient for automation verification.
          automationId = 'curtain_' + type + '_' + _.replace(message, /\./g, '_');

          window.clearTimeout(lifetimeTimeout);
          lifetimeTimeout = window.setTimeout(function() {
            self.hide();
          }, lifetime || defaultLifetime);

          applyChanges();
        };
        this.hide = function() {
          window.clearTimeout(lifetimeTimeout);
          isVisible = false;
          applyChanges();
        };
      }
    )
    .directive(
      'rcCurtainNotifications',
      /* @ngInject */
      function($animate, CurtainNotifications) {
        return {
          restrict: 'A',
          replace: true,
          scope: {},
          templateUrl: 'templates/curtain-notification.html',
          link: function(scope, element) {
            scope.curtainNotifications = CurtainNotifications;

            //Close notification
            scope.close = CurtainNotifications.hide;

            //Changes alert type by changing a class on the `element`
            var currentType = null;
            var changeAlertType = function(newType) {
              //Same type, don't do anything
              if (newType === currentType) {
                return;
              }

              //If there is a type already set, remove it
              if (currentType) {
                element.removeClass(currentType);
              }

              //Set new type to be the current type
              currentType = newType;
              element.addClass(newType);
            };

            var changeAutomationId = function(automationId) {
              element.attr('automation-id', automationId);
            };

            //Watch visibility
            scope.$watch(CurtainNotifications.isVisible, function(visible) {
              if (visible) {
                changeAlertType(CurtainNotifications.getType());
                changeAutomationId(CurtainNotifications.getAutomationId());
              }

              window.requestAnimationFrame(function() {
                $animate[visible ? 'addClass' : 'removeClass'](element, 'visible');
              });
            });

            //Watch type
            scope.$watch(CurtainNotifications.getType, function(type) {
              changeAlertType(type);
            });
          }
        };
      }
    );
})();
